'use strict';

function unescapeHtml(data) {
  return data
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"');
}

function removeScriptElements(data) {
  // regex will match self closing tag or code block - <script /> or <script></script>
  const script = /(&lt;script)([\s\S]*?)((\/&gt;)|(&lt;\/script&gt;))/gi;
  return data.replace(script, '');
}

function parse(data) {
  if (!data) return '';

  const result = removeScriptElements(data);
  return unescapeHtml(result);
}

function valueIsNotNull(localisationValue) {
  const keyMissing = /^\[missing.*translation\]$/gi;

  return !!(localisationValue && !keyMissing.test(localisationValue));
}

module.exports = { parse, valueIsNotNull };
